function handlePopup(popup) {
  const found = popup.innerText.includes('a Lev agora');
  const closeBtn = popup.querySelector('[aria-label="Close dialog"]');

  if (closeBtn) {
    closeBtn.style.display = found ? 'none' : '';
  }
}

const observer = new MutationObserver((mutations) => {
  const popup = document.querySelector('[class*="kl-private-reset-css"]');
  if (popup) {
    handlePopup(popup);
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
